/**
 * @Author:
 * @Description:
 * @DateTime: Created in 21:03 2018/11/8
 */

import {ColumnController} from 'ag-grid-community'
import _ from 'lodash'
let prototype:any = ColumnController.prototype
prototype.checkMinAndMaxWidthsForSet = function (columnResizeSet) {

	var columns = columnResizeSet.columns, width = columnResizeSet.width;
	// every col has a min width, so sum them all up and see if we have enough room
	// for all the min widths
	var minWidthAccumulated = 0
	var maxWidthAccumulated = 0
	var maxWidthActive = true
	minWidthAccumulated=minWidthAccumulated
	columns.forEach(function (col) {
		minWidthAccumulated += col.getMinWidth();
		if (col.getMaxWidth() > 0) {
			maxWidthAccumulated += col.getMaxWidth();
		}
		else {
			// if at least one columns has no max width, it means the group of columns
			// then has no max width, as at least one column can take as much width as possible
			maxWidthActive = false;
		}
	});
	var minWidthPasses = width >= 40;
	var maxWidthPasses = !maxWidthActive || (width <= maxWidthAccumulated);
	console.log('minWidthPasses', minWidthPasses);

	return minWidthPasses && maxWidthPasses;
}
prototype.resizeColumnSets = function (resizeSets, finished, source) {
	var passMinMaxCheck = _.every(resizeSets, this.checkMinAndMaxWidthsForSet.bind(this));
	console.log('passMinMaxCheck', passMinMaxCheck)

	if (!passMinMaxCheck) {
		// even though we are not going to resize beyond min/max size, we still need to raise event when finished
		if (finished) {
			var columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
			var event_3 = {
				type: 'columnResized',
				columns: columns,
				column: columns && columns.length === 1 ? columns[0] : null,
				finished: finished,
				api: this.gridApi,
				columnApi: this.columnApi,
				source: source
			};
			this.eventService.dispatchEvent(event_3);
		}
		return; // don't resize!
	}
	var changedCols:any = [];
	var allCols:any = [];
	resizeSets.forEach(function (set) {
		var width = set.width, columns = set.columns, ratios = set.ratios;
		// keep track of pixels used, and last column gets the remaining,
		// to cater for rounding errors, and min width adjustments
		var newWidths = {};
		var finishedCols = {};
		columns.forEach(function (col) { return allCols.push(col); });
		// the loop below goes through each col. if a col exceeds it's min/max width,
		// it then gets set to its min/max width and the column is removed marked as 'finished'
		// and the calculation is done again leaving this column out. take for example columns
		// {A, width: 50, maxWidth: 100}
		// {B, width: 50}
		// {C, width: 50}
		// and then the set is set to width 600 - on the first pass the grid tries to set each column
		// to 200. it checks A and sees 200 > 100 and so sets the width to 100. col A is then marked
		// as 'finished' and the calculation is done again with the remaining cols B and C, which end up
		// splitting the remaining 500 pixels.
		var finishedColsGrew = true;
		var loopCount = 0;
		var _loop_2 = function ():any {
			loopCount++;
			if (loopCount > 1000) {
				// this should never happen, but in the future, someone might introduce a bug here,
				// so we stop the browser from hanging and report bug properly
				console.error('ag-Grid: infinite loop in resizeColumnSets');
				return "break";
			}
			finishedColsGrew = false;
			var subsetCols:any = [];
			var subsetRatios:any = [];
			var subsetRatioTotal = 0;
			var pixelsToDistribute = width;
			columns.forEach(function (col, index) {
				var thisColFinished = finishedCols[col.getId()];
				if (thisColFinished) {
					pixelsToDistribute -= newWidths[col.getId()];
				}
				else {
					subsetCols.push(col);
					var ratioThisCol = ratios[index];
					subsetRatioTotal += ratioThisCol;
					subsetRatios.push(ratioThisCol);
				}
			});
			// because we are not using all of the ratios (cols can be missing),
			// we scale the ratio. if all columns are included, then subsetRatioTotal=1,
			// and so the ratioScale will be 1.
			var ratioScale = 1 / subsetRatioTotal;
			subsetCols.forEach(function (col, index) {
				var lastCol = index === (subsetCols.length - 1);
				var colNewWidth;
				if (lastCol) {
					colNewWidth = pixelsToDistribute;
				}
				else {
					colNewWidth = Math.round(ratios[index] * width * ratioScale);
					pixelsToDistribute -= colNewWidth;
				}
				if (colNewWidth < col.getMinWidth()) {
					// colNewWidth = col.getMinWidth();
					// finishedCols[col.getId()] = true;
					// finishedColsGrew = true;
				} else if (col.getMaxWidth() > 0 && colNewWidth > col.getMaxWidth()) {
					colNewWidth = col.getMaxWidth();
					finishedCols[col.getId()] = true;
					finishedColsGrew = true;
				}
				newWidths[col.getId()] = colNewWidth;
			});
		};
		while (finishedColsGrew) {
			var state_1 = _loop_2();
			if (state_1 === "break")
				break;
		}
		columns.forEach(function (col) {
			var newWidth = newWidths[col.getId()];
			if (col.getActualWidth() !== newWidth) {
				col.setActualWidth(newWidth);
				changedCols.push(col);
			}
		});
	});
	// if no cols changed, then no need to update more or send event.
	var atLeastOneColChanged = changedCols.length > 0;
	if (atLeastOneColChanged) {
		this.setLeftValues(source);
		this.updateBodyWidths();
		this.checkDisplayedVirtualColumns();
	}
	// check for change first, to avoid unnecessary firing of events
	// however we always fire 'finished' events. this is important
	// when groups are resized, as if the group is changing slowly,
	// eg 1 pixel at a time, then each change will fire change events
	// in all the columns in the group, but only one with get the pixel.
	if (atLeastOneColChanged || finished) {
		var event_4 = {
			type: 'columnResized',
			columns: allCols,
			column: allCols.length === 1 ? allCols[0] : null,
			finished: finished,
			api: this.gridApi,
			columnApi: this.columnApi,
			source: source
		};
		this.eventService.dispatchEvent(event_4);
	}
}
